import React from 'react';
import { Spinner } from '../cardStyles';
import { HeaderButton } from './style';

interface Props {
  mode: 'edit' | 'view';
  status?: string;
  podeEmitir?: boolean;
  alterado?: boolean;
  salvando?: boolean;
  onVoltar: () => void;
  onEmitir?: () => void;
  onSalvar?: () => void;
  onDescartar?: () => void;
  onEditar?: () => void;
  onCancelarNfe?: () => void;
  onVerDanfe?: () => void;
}

const InvoiceHeaderActions: React.FC<Props> = ({
  mode,
  status,
  podeEmitir = false,
  alterado = false,
  salvando = false,
  onVoltar,
  onEmitir,
  onSalvar,
  onDescartar,
  onEditar,
  onCancelarNfe,
  onVerDanfe,
}) => {
  const editavel = status === 'RASCUNHO' || status === 'NEGADA';
  const emitindo = status === 'EMITINDO';
  const emEdicao = mode === 'edit' && (editavel || emitindo);

  return (
    <>
      <HeaderButton type="button" $variant="outline" onClick={onVoltar}>
        {emEdicao ? 'Cancelar' : 'Voltar'}
      </HeaderButton>
      {onVerDanfe && (
        <HeaderButton type="button" $variant="outline" onClick={onVerDanfe}>
          Ver DANFE
        </HeaderButton>
      )}
      {status === 'EMITIDA' && onCancelarNfe && (
        <HeaderButton type="button" $variant="danger" onClick={onCancelarNfe}>
          Cancelar NF-e
        </HeaderButton>
      )}
      {emitindo && mode === 'edit' && (
        <HeaderButton type="button" disabled>
          <Spinner size={14} />
          Emitindo…
        </HeaderButton>
      )}
      {editavel && mode === 'edit' && alterado && onDescartar && (
        <HeaderButton type="button" $variant="outline" onClick={onDescartar} disabled={salvando}>
          Descartar
        </HeaderButton>
      )}
      {editavel && mode === 'edit' && alterado && onSalvar && (
        <HeaderButton type="button" onClick={onSalvar} disabled={salvando}>
          {salvando ? 'Salvando…' : 'Salvar alterações'}
        </HeaderButton>
      )}
      {editavel && mode === 'edit' && onEmitir && (
        <HeaderButton type="button" onClick={onEmitir} disabled={!podeEmitir}>
          Emitir nota
        </HeaderButton>
      )}
      {editavel && mode === 'view' && onEditar && (
        <HeaderButton type="button" onClick={onEditar}>
          Editar nota
        </HeaderButton>
      )}
    </>
  );
};

export default InvoiceHeaderActions;
